//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { FactoryUtils } from "@/utils/FactoryUtils"   
import Inform from '@/components/layer/inform.vue';

import identity from '@/components/information/identity'
import Commodity  from './components/commodity'
import { getLastIdentity } from '@/model/renewal/renewalService'
import { creatOrder } from '@/model/trader/orderService'
import { store } from '@/observable/store'

import { getParticulars } from '@/model/api/teethService'
import { Share } from '@/utils/commonUtils'
import { Parameter } from '@/utils/orderParme'
import Txrweb from '@/utils/mixin/mixinTxrweb'
import InsuranceReview from '@/utils/mixin/InsuranceReview'

export default {
    name: "index",
    mixins:[Txrweb,InsuranceReview],
    data(){
        return {
            modify:'99',
            templateFlag:'',
            mark:'', // 皮肤
            home_image:'', // 首屏
            home_button:'', // 首屏按钮
            service_image:'', // 服务
            organization_image:'', // 机构
            procedure_image:'', // 流程
            submit_button:'', // 提交按钮
            share_title:'',
            share_content:'',
            share_image:'',
            share_friend_content:'',
            share_friend_image:'',
            title:'',
            last_policy_id:0, //数据加密相关id
        }
    },
    components:{
      Commodity,
      identity,
      Inform
    },
    computed: {
        uid(){
            return store.uid
        },
        syToken(){
            return store.syToken
        },
        loginPhone(){
            return store.phone
        },
    },
    activated(){
      document.title = this.title;
    },
    watch:{
        share_title(){
            let obj = {
            'shareContent':this.share_content,
            'shareTimelineContent': this.share_title,
            'shareImgurl':  this.share_image,
            'shareTitle':  this.share_title,
            'shareUrl': `${window.location.href}`,
            'rightBtnStatus': 1
            }
            let objCircle ={
            'shareTitle':this.share_friend_content,
            'shareContent': this.share_friend_content,
            'shareUrl':  `${window.location.href}`,
            'shareImgurl': this.share_friend_image,
            'rightBtnStatus': 1
            }
            Share(obj,'sybao_ins_product_share_result_sys',objCircle)

            document.title = this.title;
        }
    },
    created() {
      this.STATISTICS('load','sybao_ins_product_info_page')
      this.templateFlag = this.$route.query.templateFlag
      if( this.$route.query.modify ){
          this.modify =  this.$route.query.modify
      }
      this.mark = this.$route.query.mark

      // 获取皮肤
      getParticulars(this.templateFlag,this.mark,this.modify).then(data=>{
        this.amountPrice = data.price.receipts_amount
        this.payable_amount = data.price.payable_amount
        if(data.content.title){
           this.title = data.content.title
        }
        this.home_image = data.content.home_image // 首屏
        this.home_button = data.content.home_button // 首屏按钮
        this.service_image = data.content.service_image // 服务
        this.organization_image = data.content.organization_image // 机构
        this.procedure_image = data.content.procedure_image // 流程
        this.submit_button = data.content.submit_button // 提交按钮
        // 分享内容
        this.share_title = data.content.share_title
        this.share_content = data.content.share_content
        this.share_image = data.content.share_image
        this.share_friend_content = data.content.share_friend_content
        this.share_friend_image = data.content.share_friend_image
        
      })
       getLastIdentity(this.templateFlag).then(data=>{
           const lastInfo = data.last_identity_info
           console.log('67890',lastInfo)
          if(lastInfo.insure_name){
              this.bus.$emit("nameInputFlag",lastInfo.insure_name);
          }
          if(lastInfo.insure_idcard){
              this.bus.$emit("idCardInputFlag",lastInfo.insure_idcard);
          }
          if(lastInfo.insure_phone){
              this.bus.$emit("phoneInputFlag",lastInfo.insure_phone);
          }
          this.last_policy_id = lastInfo.policy_id || 0
      })
    },
    mounted() {
        let obj = {
            'shareContent':this.share_content,
            'shareTimelineContent': this.share_title,
            'shareImgurl':  this.share_image,
            'shareTitle':  this.share_title,
            'shareUrl': `${window.location.href}`,
            'rightBtnStatus': 1
        }
        let objCircle ={
            'shareTitle':this.share_friend_content,
            'shareContent': this.share_friend_content,
            'shareUrl':  `${window.location.href}`,
            'shareImgurl': this.share_friend_image,
            'rightBtnStatus': 1
        }
        Share(obj,'sybao_ins_product_share_result_sys',objCircle)
    },
    methods:{
      creadInfo(){
        this.$refs.identityRef.creadInfo()
      },
      identityInfo(msg){
          

          let parmer = {
              modify:this.modify,
              applicant:{  //投保人对象
                  phone:msg.phone,//手机号
                  name:msg.name,//姓名
                  idcard:msg.idcard//身份证号码
              },
              template:this.templateFlag, // 接口名
              amount:this.amountPrice/100, //实付金额
              payable_amount:this.payable_amount/100, //应付金额 
              traceback:store.TXoption.bizKey,
              last_policy_id:this.last_policy_id
          }

          const parameter = Parameter(parmer)
          //核保   
          this.insuranceToReview(parameter,'creatOrder')
        //   creatOrder(parameter).then(data=>{
        //       // 更新可回溯信息
        //       this.updataTX(parameter.applicant, data.out_trade_no)
              
        //       this.STATISTICS('click','sybao_ins_proinfo_pay_cashier_click')
        //       this.$router.push({
        //           path: "/pay",
        //           query:{
        //               outTrade:data.out_trade_no,
        //               uuid:data.uuid,
        //               paySuccessSate:'activation'
        //           }
        //       });
                
        //   }).catch(err=>{
        //       if(err.code == '1201'){
        //           // 跳转重复领取
        //           this.$router.push({
        //                 path: "/happySuccess",
        //                 query:{
        //                     templateFlag:this.templateFlag,
        //                     codeNumber:75
        //                 }
        //             });
        //       }else{
        //           this.$toast(err.message);
        //       }
        //   })
        }
    }
}
